/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTargetState } from './rolloutTargetState';


export interface TargetSummary { 
    state?: RolloutTargetState;
    count?: number;
}
export namespace TargetSummary {
}


